/* eslint-disable */
import React, { useEffect, useContext, useState, useMemo } from "react";
import { WebSocketContext } from "../../../App";
import wsSend_request from "../../../Api/ws/ws_request";
import { useSelector, useDispatch } from "react-redux";
import CommonDateTime from "../../Common/CommonDateTime";
import { updateOrderManagementFilter } from "../../../redux/actions/adminActions";
import MainOrderDataTableFilter from "../../Common/MainOrderDataTableFilter";
import CommonTable from "../../Common/CommonTable";
import CommonLoader from "../../Common/CommonLoader";

const FranchiseDraftOrdersReport = () => {
  const Dispatch = useDispatch();

  const { websocket } = useContext(WebSocketContext);
  const {
    device_id,
    DraftOrderReportList,
    OrderManagmentFilter,
    sortingfor,
    selfInfo,
  } = useSelector((state) => state.adminReducers);
  const PermissionsAccess = selfInfo?.user?.permissions_access;
  // page change
  const currentFunction = (page) => {
    Dispatch(
      updateOrderManagementFilter({
        DraftOrdersReport: {
          CurrentPage: page,
        },
      }),
    );
  };
  // get all product list
  useEffect(() => {
    let param = {
      transmit: "broadcast",
      url: "product_list",
      request: {
        status: true,
        limit: 5000,
        page_no: 1,
        search: "",
      },
      DeviceId: device_id,
    };
    wsSend_request(websocket, param);
  }, [websocket]);

  // get all warehouse list
  useEffect(() => {
    let param = {
      transmit: "broadcast",
      url: "warehouse_list",
      request: {
        status: "",
        limit: 5000,
        page_no: 1,
        search: "",
      },
      DeviceId: device_id,
    };
    wsSend_request(websocket, param);
  }, [websocket]);

  // get all region list
  useEffect(() => {
    let param = {
      transmit: "broadcast",
      url: "region_list",
      request: {
        status: "",
        limit: 5000,
        page_no: 1,
        search: "",
      },
      DeviceId: device_id,
    };
    wsSend_request(websocket, param);
  }, [websocket]);

  // api calling
  const APICall = () => {
    const draftFilter = OrderManagmentFilter?.DraftOrdersReport ?? {};
    const {
      SelectOrderType,
      SelectDateType,
      UserLimit,
      UserSearch,
      SelectRegion,
      OrderSource,
      FromDate,
      ToDate,
      CurrentPage,
      WarehouseName,
      ProductName,
      is_bundle_orders,
      is_select_checkbox,
    } = draftFilter;

    let param = {
      transmit: "broadcast",
      url: "order_list",
      request: {
        status: SelectOrderType,
        limit: UserLimit ?? 10,
        page_no: CurrentPage ?? 1,
        search: (UserSearch ?? "").trim(),
        from_date: null,
        to_date: null,
        from_inv: null,
        to_inv: null,
        order_type: OrderSource ?? "",
        region_id: SelectRegion ?? "",
        order_by: sortingfor,
        fetch_location_info: true,
        is_bundle_orders: is_bundle_orders ?? false,
        pin_code_flag: "all",
      },
      DeviceId: device_id,
    };
    if (SelectDateType === "created_at") {
      if (FromDate !== "" && ToDate !== "") {
        param.request.from_date = CommonDateTime(
          FromDate,
          "YYYY-MM-DD",
          "hide",
        );
        param.request.to_date = CommonDateTime(ToDate, "YYYY-MM-DD", "hide");
      }
    } else {
      if (FromDate !== "" && ToDate !== "") {
        param.request.from_updated_date = CommonDateTime(
          FromDate,
          "YYYY-MM-DD",
          "hide",
        );
        param.request.to_updated_date = CommonDateTime(
          ToDate,
          "YYYY-MM-DD",
          "hide",
        );
      }
    }

    if (WarehouseName) {
      param.request.warehouse_id = WarehouseName?.map(
        (elm) => elm?.value,
      )?.toString();
    }

    if (ProductName) {
      param.request.product_id = ProductName?.map(
        (elm) => elm?.value,
      )?.toString();
    }
    wsSend_request(websocket, param);
  };

  useEffect(() => {
    APICall();
  }, [websocket, OrderManagmentFilter?.DraftOrdersReport]);

  useEffect(() => {
    if (sortingfor !== "" && sortingfor !== "-") {
      APICall();
    }
  }, [sortingfor]);

  // TABLE COLUMNS ARRAY
  const TableColumns = [
    // {
    //   key: "shipping_manifest_link",
    //   label: "Shipping Manifest Link",
    //   type: "shipping_manifest_link_download",
    //   sort: "",
    //   isCollapsable: false,
    // },
    {
      key: "customer_name",
      label: "SHIP To Name",
      type: "label",
      sort: "customer_name",
      isCollapsable: false,
    },
    {
      key: "pin_code",
      label: "SHIP Pincode",
      type: "label",
      sort: "pin_code_id",
      isCollapsable: false,
    },
    {
      key: "state",
      label: "SHIP State",
      type: "label",
      sort: "state_id",
      isCollapsable: false,
    },
    {
      key: "district",
      label: "SHIP City",
      type: "label",
      sort: "district_id",
      isCollapsable: false,
    },
    {
      key: "billing_id",
      label: "BILL To Name",
      type: "label_get_from_franchise",
      sort: "billing_id",
      isCollapsable: false,
    },
    {
      key: "order_code",
      label: "Order Id.",
      type: "order_details",
      sort: "order_code",
      isCollapsable: false,
    },
    {
      key: "customer_identity",
      label: "Customer Code",
      type: "label",
      sort: "customer_identity",
      isCollapsable: false,
    },
    {
      key: "created_at",
      label: "Order Date",
      type: "date",
      sort: "created_at",
      isCollapsable: false,
    },
    {
      key: "qty",
      label: "Qty",
      type: "label",
      sort: "qty",
      isCollapsable: false,
    },
    {
      key: "total",
      label: "Amount",
      type: "label_day_ammount",
      sort: "total",
      isCollapsable: false,
    },
    {
      key: "order_status",
      label: "Status",
      type: "label_order_status",
      sort: "",
      isCollapsable: false,
    },
  ];

  const [selectedIds, setSelectedIds] = useState(new Set());

  const selectedIdList = useMemo(() => Array.from(selectedIds), [selectedIds]);
  const [ Loader, setLoader ] = useState(false);
  return (
    <section className="Main_section">
      {Loader && <CommonLoader />}

      <MainOrderDataTableFilter
        filterType={""}
        tabName={"DraftOrdersReport"}
        searchType={"Order Id, Customer Code"}
        FromDateStartDateFlag={true}
        searchdisable={true}
        buttonvisible={false}
        AllOrderStatusAllow={true}
        isAllowWarehouse={true}
        isAllowProduct={true}
        isDateType={false}
        isOdiFilterAllow={false}
        isRegionAllow={true}
        isBundleOrdersAllow={true}
        // isSelectCheckBox={true}
        isOrderSourceAllow={false}
        // selectedOrderList={selectedIdList}
        APIcalling={APICall}
        setLoader={setLoader}
      />
      {/* COMMON TABLE */}
      <CommonTable
        isTableAllow={true}
        style={{
          height:
            parseInt(DraftOrderReportList?.pagination?.total_records) ===
            DraftOrderReportList?.list?.length
              ? "calc(100vh - 196px)"
              : parseInt(DraftOrderReportList?.pagination?.total_records) > 10
                ? "calc(100vh - 235px)"
                : "calc(100vh - 196px)",
        }}
        srNumber={{
          clickable: true,
          events: "ORDERS_LOG",
        }}
        // isCollapsable={true}
        tabName={""} // TAB URL
        PaginationCurrentPage={
          OrderManagmentFilter["DraftOrdersReport"]?.CurrentPage
        } // TAB CURRENT PAGE
        PaginationFunction={currentFunction} // PAGINATION CHNAGE FUNCTION
        TableColumns={TableColumns} // TABLE COLLUMNS & ROWS
        OrderList={DraftOrderReportList} // ORDER LIST
        Pagination={DraftOrderReportList?.pagination} // CURRENT TAB PAGINATION
        EditAccess={
          selfInfo?.user?.user_type === "super_admin" ||
          PermissionsAccess?.OrderManagement[20]?.Edit
        } // EDITABLE ACCESS STATE
        APIcalling={APICall}
        isActionColumnAvailable={{
          isShow: false,
          label: "",
          naviagte: null,
        }}
        isActionTwoColumnAvailable={{
          isShow: false,
          url: "",
        }}
        isOdiFilterRowColorsAllow={false}
        // isSelectOrder={
        //   OrderManagmentFilter?.DraftOrdersReport?.is_select_checkbox
        // }
        // selectedIds={selectedIds}
        // setSelectedIds={setSelectedIds}
      />
    </section>
  );
};

export default FranchiseDraftOrdersReport;
